import { render, staticRenderFns } from "./SendFormPanel.vue?vue&type=template&id=fcb16aec&scoped=true"
import script from "./SendFormPanel.vue?vue&type=script&lang=js"
export * from "./SendFormPanel.vue?vue&type=script&lang=js"
import style0 from "./SendFormPanel.vue?vue&type=style&index=0&id=fcb16aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb16aec",
  null
  
)

export default component.exports